(function () {
  function norm(t) { return (t || "").replace(/\s+/g, " ").trim().toLowerCase(); }
  function isQuizLink(a) { return norm(a.textContent) === "take the quiz"; }

  function handleQuizButtonClick(event) {
      event.preventDefault();
      openQuizPopupCustom();
    }

  function bind(a) {
    if (!a || a.dataset.quizBound) return;
    a.dataset.quizBound = "1";

    a.addEventListener("click", function (e) {
      if (isQuizLink(a)) {
        e.preventDefault();
        if (typeof handleQuizButtonClick === "function") {
          handleQuizButtonClick(e);
        } else {
          console.warn("handleQuizButtonClick is not defined");
        }
      }
    });

    // Keyboard support (Enter/Space)
    a.addEventListener("keydown", function (e) {
      if (isQuizLink(a) && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        if (typeof handleQuizButtonClick === "function") {
          handleQuizButtonClick(e);
        }
      }
    });
  }

  function scan() {
    document.querySelectorAll("a").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  // Catch dynamically-added links
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
